// extracted by mini-css-extract-plugin
module.exports = {"img":"Product_img__21Ej_","logo":"Product_logo__2Xagi","mobile":"Product_mobile__2MybG"};